var _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgOptionUnchecked = function SvgOptionUnchecked(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.99909,
    y: 1.99915,
    width: 20.0018,
    height: 20.0018,
    rx: 10.0009,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.99909,
    y: 1.99915,
    width: 20.0018,
    height: 20.0018,
    rx: 10.0009,
    stroke: "#E2E2E2",
    strokeWidth: 2.00182
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgOptionUnchecked);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMS45OTkwOSIgeT0iMS45OTkxNSIgd2lkdGg9IjIwLjAwMTgiIGhlaWdodD0iMjAuMDAxOCIgcng9IjEwLjAwMDkiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHg9IjEuOTk5MDkiIHk9IjEuOTk5MTUiIHdpZHRoPSIyMC4wMDE4IiBoZWlnaHQ9IjIwLjAwMTgiIHJ4PSIxMC4wMDA5IiBzdHJva2U9IiNFMkUyRTIiIHN0cm9rZS13aWR0aD0iMi4wMDE4MiIvPgo8L3N2Zz4K";